import * as actionTypes from '../actionTypes/gameActionTypes'
import { GameState } from '../types/game'
import i18next from '../../i18n'
import jwt_decode from 'jwt-decode'

const getSelectedLanguage = () => {
  const sessionLang = localStorage.getItem(`hunt-lang`)
  if (sessionLang) {
    const selectedLanguage = JSON.parse(sessionLang)
    i18next.changeLanguage(selectedLanguage.code)
    return selectedLanguage
  }

  return null
}

const getBranding = () => {
  const token = localStorage.getItem(`tokenCityHunt`)
  if (token) {
    const { Branding }: any = jwt_decode(token)
    return JSON.parse(Branding)
  }

  return null
}

const getGameLocaleId = () => {
  const token = localStorage.getItem(`tokenCityHunt`)
  if (token) {
    const { LocaleId }: any = jwt_decode(token)
    return Number(LocaleId)
  }

  return null
}

const getInitialData = () => {
  let initialData: any = localStorage.getItem(`hunt-branding`)
  if (initialData) {
    initialData = JSON.parse(initialData)
    return {
      branding: JSON.parse(initialData.branding),
      logoUrl: initialData.logoUrl,
      primaryColor: initialData.primaryColor,
    }
  }

  return null
}

const initialState: GameState = {
  data: {
    partners: [],
    gameCode: null,
    teamName: null,
    bookGame: null,
    bookedGamesByUser: null,
    bookedGamesByCities: null,
    bookedGamesTotalsInRange: null,
    bookedGamesTotals: null,
    leaderboard: null,
    teamOnLeaderboard: null,
    gamesByUser: null,
    welcomeScreen: { html: '' },
    endScreen: { html: '' },
    gameLocales: null,
    mapStyle: null,
    locationsOnMap: null,
    puzzleAnswer: null,
    questionByLocale: null,
    // puzzleHint: null,
    usedHints: null,
    skipPuzzle: null,
    selectedLanguage: getSelectedLanguage(),
    collectedItems: [],
    isTeamNameAdded: false,
    finalPuzzle: null,
    wellDoneBackground: null,
    progress: null,
    volumeGlobal: 90 / 100,
    legalUrls: null,
    solvedPuzzles: null,
    branding: getBranding(),
    initialData: getInitialData(),
    gameTimerDialog: null,
    gameTimerReminderDialog: null,
    consentHtml: { html: '' },
    instructionsHtml: { html: '' },
    gameLocaleId: getGameLocaleId(),
  },
  loading: {
    isLoadingLegalUrls: false,
    isLoadingPartners: false,
    isCheckingGameCode: false,
    isSavingTeamName: false,
    isSavingBookGame: false,
    isLoadingBookedGamesByUser: false,
    isLoadingBookedGamesByCities: false,
    isLoadingBookedGamesTotalsInRange: false,
    isLoadingBookedGamesTotals: false,
    isLoadingLeaderboard: false,
    isLoadingTeamOnLeaderboard: false,
    isLoadingGamesByUser: false,
    isLoadingWelcomeScreen: false,
    isLoadingEndScreen: false,
    isLoadingGameLocales: false,
    isLoadingMapStyle: false,
    isLoadingLocationsOnMap: false,
    isCheckingPuzzleAnswer: false,
    isLoadingQuestionByLocale: false,
    isLoadingPuzzleHint: false,
    isLoadingUsedHints: false,
    isLoadingSkipPuzzle: false,
    isLoadingCollectedItems: false,
    isLoadingTeamNameExists: false,
    isLoadingFinalPuzzle: false,
    isLoadingTeamName: false,
    isLoadingProgress: false,
    isLoadingLogout: false,
    isSavingWellDoneBackground: false,
    isLoadingIsPuzzleSolved: false,
    isLoadingInitialData: false,
    isLoadingConsentHtml: false,
    isLoadingInstructionsHtml: false,
  },
  timestamp: null,
  error: null,
}

const gameReducer = (state = initialState, action: any) => {
  switch (action.type) {
    //-----------------------------------------------------------------
    case actionTypes.CHANGE_GLOBAL_VOLUME:
      return {
        ...state,
        data: {
          ...state.data,
          volumeGlobal: action.payload / 100,
        },
      }
    //-----------------------------------------------------------------
    case actionTypes.FETCH_PARTNERS_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingPartners: true,
        },
      }
    case actionTypes.FETCH_PARTNERS_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingPartners: false,
        },
        data: { ...state.data, partners: action.payload.partners },
        error: null,
      }
    case actionTypes.FETCH_PARTNERS_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingPartners: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    case actionTypes.POST_GAME_CODE_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isCheckingGameCode: true,
        },
      }
    case actionTypes.POST_GAME_CODE_SUCCESS:
      const { Branding, LocaleId }: any = jwt_decode(action.payload.data)
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isCheckingGameCode: false,
        },
        data: {
          ...state.data,
          // gameCode: action.payload.data,
          branding: JSON.parse(Branding),
          gameLocaleId: Number(LocaleId),
        },
        error: null,
      }
    case actionTypes.POST_GAME_CODE_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isCheckingGameCode: false,
        },
        // data: { ...state.data, gameData: null },
        error: action.payload.error,
      }
    case actionTypes.POST_TEAM_NAME_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isSavingTeamName: true,
        },
      }
    case actionTypes.POST_TEAM_NAME_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isSavingTeamName: false,
        },
        data: { ...state.data, teamName: action.payload.data },
        error: null,
      }
    case actionTypes.POST_TEAM_NAME_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isSavingTeamName: false,
        },
        // data: { ...state.data, gameData: null },
        error: action.payload.error,
      }
    case actionTypes.PUT_TEAM_NAME_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isSavingTeamName: true,
        },
      }
    case actionTypes.PUT_TEAM_NAME_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isSavingTeamName: false,
        },
        data: { ...state.data, teamName: action.payload.data },
        error: null,
      }
    case actionTypes.PUT_TEAM_NAME_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isSavingTeamName: false,
        },
        // data: { ...state.data, gameData: null },
        error: action.payload.error,
      }
    case actionTypes.POST_BOOK_GAME_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isSavingBookGame: true,
        },
      }
    case actionTypes.POST_BOOK_GAME_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isSavingBookGame: false,
        },
        data: { ...state.data, bookGame: action.payload.data },
        error: null,
      }
    case actionTypes.POST_BOOK_GAME_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isSavingBookGame: false,
        },
        // data: { ...state.data, gameData: null },
        error: action.payload.error,
      }
    case actionTypes.POST_FREE_GAME_LOGIN_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          isSavingBookGame: true,
        },
      }
    case actionTypes.POST_FREE_GAME_LOGIN_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          isSavingBookGame: false,
        },
        error: null,
      }
    case actionTypes.POST_FREE_GAME_LOGIN_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          isSavingBookGame: false,
        },
        error: action.payload.error,
      }
    case actionTypes.FETCH_BOOKED_GAMES_BY_USER_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingBookedGamesByUser: true,
        },
      }
    case actionTypes.FETCH_BOOKED_GAMES_BY_USER_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingBookedGamesByUser: false,
        },
        data: { ...state.data, bookedGamesByUser: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_BOOKED_GAMES_BY_USER_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingBookedGamesByUser: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    case actionTypes.FETCH_BOOKED_GAMES_BY_CITIES_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingBookedGamesByCities: true,
        },
      }
    case actionTypes.FETCH_BOOKED_GAMES_BY_CITIES_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingBookedGamesByCities: false,
        },
        data: { ...state.data, bookedGamesByCities: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_BOOKED_GAMES_BY_CITIES_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingBookedGamesByCities: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    case actionTypes.FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingBookedGamesTotalsInRange: true,
        },
      }
    case actionTypes.FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingBookedGamesTotalsInRange: false,
        },
        data: { ...state.data, bookedGamesTotalsInRange: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingBookedGamesTotalsInRange: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    case actionTypes.FETCH_BOOKED_GAMES_TOTALS_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingBookedGamesTotals: true,
        },
      }
    case actionTypes.FETCH_BOOKED_GAMES_TOTALS_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingBookedGamesTotals: false,
        },
        data: { ...state.data, bookedGamesTotals: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_BOOKED_GAMES_TOTALS_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingBookedGamesTotals: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    case actionTypes.FETCH_LEADERBOARD_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingLeaderboard: true,
        },
      }
    case actionTypes.FETCH_LEADERBOARD_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingLeaderboard: false,
        },
        data: { ...state.data, leaderboard: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_LEADERBOARD_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingLeaderboard: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    case actionTypes.FETCH_TEAM_ON_LEADERBOARD_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingTeamOnLeaderboard: true,
        },
      }
    case actionTypes.FETCH_TEAM_ON_LEADERBOARD_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingTeamOnLeaderboard: false,
        },
        data: { ...state.data, teamOnLeaderboard: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_TEAM_ON_LEADERBOARD_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingTeamOnLeaderboard: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    case actionTypes.FETCH_GAMES_BY_USER_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingGamesByUser: true,
        },
      }
    case actionTypes.FETCH_GAMES_BY_USER_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingGamesByUser: false,
        },
        data: { ...state.data, gamesByUser: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_GAMES_BY_USER_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingGamesByUser: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    case actionTypes.FETCH_GAME_CODE_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          data: {
            ...state.data,
            gameCode: null,
          },
          isCheckingGameCode: true,
        },
      }
    case actionTypes.FETCH_GAME_CODE_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isCheckingGameCode: false,
        },
        data: { ...state.data, gameCode: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_GAME_CODE_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isCheckingGameCode: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    case actionTypes.FETCH_WELCOME_SCREEN_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          data: {
            ...state.data,
            welcomeScreen: null,
          },
          isLoadingWelcomeScreen: true,
        },
      }
    case actionTypes.FETCH_WELCOME_SCREEN_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingWelcomeScreen: false,
        },
        data: { ...state.data, welcomeScreen: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_WELCOME_SCREEN_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingWelcomeScreen: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    case actionTypes.FETCH_END_SCREEN_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          data: {
            ...state.data,
            endScreen: null,
          },
          isLoadingEndScreen: true,
        },
      }
    case actionTypes.FETCH_END_SCREEN_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingEndScreen: false,
        },
        data: { ...state.data, endScreen: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_END_SCREEN_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          isLoadingEndScreen: false,
        },
        error: action.payload.error,
      }
    case actionTypes.FETCH_GAME_LOCALES_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingGameLocales: true,
        },
      }
    case actionTypes.FETCH_GAME_LOCALES_SUCCESS: {
      const token = localStorage.getItem('tokenCityHunt') ?? ''
      let GameId: string | null = null
      let GameCode: string | null = null

      try {
        const decoded: any = jwt_decode(token)
        GameId = decoded.GameId
        GameCode = decoded.GameCode
      } catch (e) {
        console.warn('Invalid token:', e)
      }

      let selectedLanguage = getSelectedLanguage()

      if (!selectedLanguage) {
        const bookedGameLocaleId = getGameLocaleId()

        if (bookedGameLocaleId) {
          selectedLanguage = action.payload.data.find(
            (el: any) => el.id === bookedGameLocaleId,
          )
        } else {
          // 👉 Fallback: pick the first active locale
          selectedLanguage = action.payload.data.find((el: any) => el.isActive)
        }

        if (selectedLanguage) {
          i18next.changeLanguage(selectedLanguage.code)
          localStorage.setItem(
            'hunt-lang',
            JSON.stringify({
              ...selectedLanguage,
              gameId: GameId,
              gameCode: GameCode,
            }),
          )
        }
      }

      return {
        ...state,
        loading: {
          ...state.loading,
          isLoadingGameLocales: false,
        },
        data: {
          ...state.data,
          gameLocales: action.payload.data,
          selectedLanguage: selectedLanguage,
        },
        error: null,
      }
    }

    case actionTypes.FETCH_GAME_LOCALES_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingGameLocales: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    case actionTypes.FETCH_MAP_STYLE_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingMapStyle: true,
        },
      }
    case actionTypes.FETCH_MAP_STYLE_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingMapStyle: false,
        },
        data: { ...state.data, mapStyle: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_MAP_STYLE_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingMapStyle: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    case actionTypes.FETCH_LOCATIONS_ON_MAP_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingLocationsOnMap: true,
        },
      }
    case actionTypes.FETCH_LOCATIONS_ON_MAP_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingLocationsOnMap: false,
        },
        data: {
          ...state.data,
          locationsOnMap: action.payload.data,
          questionByLocale: null,
        },
        error: null,
      }
    case actionTypes.FETCH_LOCATIONS_ON_MAP_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingLocationsOnMap: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    // PUZZLE_ANSWER
    case actionTypes.POST_PUZZLE_ANSWER_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isCheckingPuzzleAnswer: true,
        },
        data: { ...state.data, puzzleAnswer: null },
      }
    case actionTypes.POST_PUZZLE_ANSWER_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isCheckingPuzzleAnswer: false,
        },
        data: { ...state.data, puzzleAnswer: action.payload.data },
        error: null,
      }
    case actionTypes.POST_PUZZLE_ANSWER_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isCheckingPuzzleAnswer: false,
        },
        // data: { ...state.data, gameData: null },
        error: action.payload.error,
      }
    // QUESTION_BY_LOCALE
    case actionTypes.FETCH_QUESTION_BY_LOCALE_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingQuestionByLocale: true,
        },
      }
    case actionTypes.FETCH_QUESTION_BY_LOCALE_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingQuestionByLocale: false,
        },
        data: {
          ...state.data,
          questionByLocale: action.payload.data,
          skipPuzzle: null,
        },
        error: null,
      }
    case actionTypes.FETCH_QUESTION_BY_LOCALE_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          isLoadingQuestionByLocale: false,
        },
        error: action.payload.error,
      }
    case actionTypes.FETCH_QUESTION_SOLVED_PUZZLE_BY_LOCALE_SUCCESS:
      if (action.payload.typeOfAction === 'correctAnswer') {
        return {
          ...state,
          data: {
            ...state.data,
            puzzleAnswer: action.payload.data,
          },
          error: null,
        }
      } else {
        return {
          ...state,
          data: {
            ...state.data,
            skipPuzzle: action.payload.data,
          },
          error: null,
        }
      }

    case actionTypes.FETCH_QUESTION_SOLVED_PUZZLE_BY_LOCALE_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingQuestionByLocale: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    case actionTypes.FETCH_IS_QUESTION_SOLVED_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingIsPuzzleSolved: true,
        },
      }
    case actionTypes.FETCH_IS_QUESTION_SOLVED_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingIsPuzzleSolved: false,
        },

        data: {
          ...state.data,
          solvedPuzzles: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...state.solvedPuzzles,
            [action.payload.questionId]: action.payload.data.isPuzzleSolved,
          },
          puzzleAnswer: action.payload.data.wellDoneResponse,
          skipPuzzle: action.payload.data.skipResponse,
        },
        error: null,
      }
    case actionTypes.FETCH_IS_QUESTION_SOLVED_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingIsPuzzleSolved: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    // PUZZLE_HINT
    case actionTypes.POST_PUZZLE_HINT_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingUsedHints: true,
          // isLoadingPuzzleHint: true,
        },
      }
    case actionTypes.POST_PUZZLE_HINT_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingUsedHints: false,
          // isLoadingPuzzleHint: false,
        },
        // data: { ...state.data, puzzleHint: action.payload.data },
        error: null,
      }
    case actionTypes.POST_PUZZLE_HINT_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingUsedHints: false,
          // isLoadingPuzzleHint: false,
        },
        // data: { ...state.data, gameData: null },
        error: action.payload.error,
      }
    // USED_HINTS
    case actionTypes.FETCH_USED_HINTS_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingUsedHints: true,
        },
      }
    case actionTypes.FETCH_USED_HINTS_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingUsedHints: false,
        },
        data: { ...state.data, usedHints: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_USED_HINTS_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingUsedHints: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    // SKIP_PUZZLE
    case actionTypes.POST_SKIP_PUZZLE_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingSkipPuzzle: true,
        },
        data: { ...state.data, skipPuzzle: null },
      }
    case actionTypes.POST_SKIP_PUZZLE_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingSkipPuzzle: false,
        },
        data: { ...state.data, skipPuzzle: action.payload.data },
        error: null,
      }
    case actionTypes.POST_SKIP_PUZZLE_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingSkipPuzzle: false,
        },
        // data: { ...state.data, gameData: null },
        error: action.payload.error,
      }
    // Selected Language
    case actionTypes.CHANGE_SELECTED_LANGUAGE:
      return {
        ...state,
        data: { ...state.data, selectedLanguage: action.payload },
      }
    case actionTypes.RESET_PUZZLE_ANSWER:
      return {
        ...state,
        data: {
          ...state.data,
          puzzleAnswer: null,
          skipPuzzle: null,
          wellDoneBackground: null,
          usedHints: null,
        },
      }
    // COLLECTED_ITEMS
    case actionTypes.FETCH_COLLECTED_ITEMS_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingCollectedItems: true,
        },
      }
    case actionTypes.FETCH_COLLECTED_ITEMS_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingCollectedItems: false,
        },
        data: { ...state.data, collectedItems: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_COLLECTED_ITEMS_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingCollectedItems: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    // INITIAL DATA
    case actionTypes.FETCH_INITIAL_DATA_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingInitialData: true,
        },
      }
    case actionTypes.FETCH_INITIAL_DATA_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingInitialData: false,
        },
        data: {
          ...state.data,
          initialData: {
            branding: JSON.parse(action.payload.data.branding),
            logoUrl: action.payload.data.logoUrl,
            primaryColor: action.payload.data.primaryColor,
          },
        },
        error: null,
      }
    case actionTypes.FETCH_INITIAL_DATA_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingCollectedItems: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    //CHECK IF TEAM NAME EXISTS
    case actionTypes.CHECK_IF_TEAM_NAME_IS_ADDED_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingTeamNameExists: true,
        },
      }
    case actionTypes.CHECK_IF_TEAM_NAME_IS_ADDED_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingTeamNameExists: false,
        },
        data: { ...state.data, isTeamNameAdded: action.payload },
        error: null,
      }
    case actionTypes.CHECK_IF_TEAM_NAME_IS_ADDED_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingTeamNameExists: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload,
      }
    // FINAL_PUZZLE
    case actionTypes.FETCH_FINAL_PUZZLE_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingFinalPuzzle: true,
        },
      }
    case actionTypes.FETCH_FINAL_PUZZLE_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingFinalPuzzle: false,
        },
        data: { ...state.data, finalPuzzle: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_FINAL_PUZZLE_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingFinalPuzzle: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    // TEAM NAME
    case actionTypes.FETCH_TEAM_NAME_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          isLoadingTeamName: true,
        },
      }
    case actionTypes.FETCH_TEAM_NAME_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          isLoadingTeamName: false,
        },
        data: { ...state.data, teamName: action.payload },
      }
    case actionTypes.FETCH_TEAM_NAME_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingTeamName: false,
        },
        error: action.payload,
      }
    // PROGRESS
    case actionTypes.FETCH_PROGRESS_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          isLoadingProgress: true,
        },
      }
    case actionTypes.FETCH_PROGRESS_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          isLoadingProgress: false,
        },
        data: { ...state.data, progress: action.payload },
      }
    case actionTypes.FETCH_PROGRESS_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingProgress: false,
        },
        error: action.payload,
      }
    // USED_HINTS
    case actionTypes.FETCH_USED_HINTS_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingUsedHints: true,
        },
      }
    case actionTypes.FETCH_USED_HINTS_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingUsedHints: false,
        },
        data: { ...state.data, usedHints: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_USED_HINTS_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingUsedHints: false,
        },
        // data: { ...state.data, partners: [] },
        error: action.payload.error,
      }
    // LOGOUT
    case actionTypes.POST_LOGOUT_REQUEST:
      return {
        ...state,
        // isLoading: true,
        loading: {
          ...state.loading,
          isLoadingLogout: true,
        },
      }
    case actionTypes.POST_LOGOUT_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingLogout: false,
        },
        // data: { ...state.data, Logout: action.payload.data },
        error: null,
      }
    case actionTypes.POST_LOGOUT_FAILURE:
      return {
        ...state,
        // isLoading: false,
        loading: {
          ...state.loading,
          isLoadingLogout: false,
        },
        // data: { ...state.data, gameData: null },
        error: action.payload.error,
      }
    // WELL_DONE_BACKGROUND
    case actionTypes.FETCH_WELL_DONE_BACKGROUND_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          isSavingWellDoneBackground: true,
        },
      }
    case actionTypes.FETCH_WELL_DONE_BACKGROUND_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          isSavingWellDoneBackground: false,
        },
        data: {
          ...state.data,
          wellDoneBackground: action.payload.data,
        },
        error: null,
      }
    case actionTypes.FETCH_WELL_DONE_BACKGROUND_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          isSavingWellDoneBackground: false,
        },
        // data: { ...state.data, welcomeScreen: null },
        error: action.payload.error,
      }
    // WELL_DONE_BACKGROUND
    case actionTypes.FETCH_LEGAL_URLS_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          isLoadingLegalUrls: true,
        },
      }
    case actionTypes.FETCH_LEGAL_URLS_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          isLoadingLegalUrls: false,
        },
        data: {
          ...state.data,
          legalUrls: action.payload,
        },
        error: null,
      }
    case actionTypes.FETCH_LEGAL_URLS_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          isLoadingLegalUrls: false,
        },
        // data: { ...state.data, welcomeScreen: null },
        error: action.payload.error,
      }
    case actionTypes.SET_PUZZLE_ANSWER:
      return {
        ...state,
        data: { ...state.data, puzzleAnswer: action.payload },
      }
    case actionTypes.SET_GAME_TIMER_DIALOG:
      return {
        ...state,
        data: { ...state.data, gameTimerDialog: action.payload },
      }
    case actionTypes.SET_GAME_TIMER_REMINDER_DIALOG:
      return {
        ...state,
        data: { ...state.data, gameTimerReminderDialog: action.payload },
      }
    case actionTypes.FETCH_GAME_CONSENT_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          isSavingConsentHtml: true,
        },
        data: { ...state.data, consentHtml: null },
      }
    case actionTypes.FETCH_GAME_CONSENT_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          isSavingConsentHtml: false,
        },
        data: { ...state.data, consentHtml: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_GAME_CONSENT_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          isSavingConsentHtml: false,
        },
        // data: { ...state.data, puzzleQuestion: null },
        error: action.payload.error,
      }
    case actionTypes.FETCH_GAME_INSTRUCTIONS_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          isLoadingInstructionsHtml: true,
        },
        data: { ...state.data, instructionsHtml: null },
      }
    case actionTypes.FETCH_GAME_INSTRUCTIONS_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          isLoadingInstructionsHtml: false,
        },
        data: { ...state.data, instructionsHtml: action.payload.data },
        error: null,
      }
    case actionTypes.FETCH_GAME_INSTRUCTIONS_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          isLoadingInstructionsHtml: false,
        },
        // data: { ...state.data, puzzleQuestion: null },
        error: action.payload.error,
      }
    default:
      return {
        ...state,
      }
  }
}

export default gameReducer
